interface FAQItem {
  question: string;
  answer: string;
}

export default function BlogFAQ({ faqs }: { faqs: FAQItem[] }) {
  if (!faqs || faqs.length === 0) return null;

  return (
    <section aria-labelledby="faq-heading" className="mt-12">
      <h2 id="faq-heading" className="text-xl font-bold text-foreground-950 mb-6 flex items-center gap-2">
        <i className="ri-question-answer-line text-primary-500"></i>
        Frequently Asked Questions
      </h2>

      <div className="space-y-3">
        {faqs.map((faq, idx) => (
          <details key={idx} className="bg-background-50 border border-background-200 rounded-xl group">
            <summary className="px-5 py-4 cursor-pointer flex items-center justify-between gap-4 list-none">
              <span className="text-sm font-semibold text-foreground-900">{faq.question}</span>
              <i className="ri-add-line text-foreground-400 group-open:hidden text-lg flex-shrink-0"></i>
              <i className="ri-subtract-line text-foreground-400 hidden group-open:block text-lg flex-shrink-0"></i>
            </summary>
            <div className="px-5 pb-4">
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}